import React, { useState, createRef, useEffect } from 'react'
import { useResizeDetector, withResizeDetector } from '../ResizeDetector';

export const Container = (props: any) => {
  const [count, setCount] = useState(0);
  const [vars, setVars] = useState({})
  const { definition = [], refreshRate = 2000, skipOnMount = false, ...rest } = props
  const { width, height, ref } = useResizeDetector<HTMLDivElement>({ refreshMode: 'debounce', refreshRate: refreshRate, skipOnMount: skipOnMount });
  // { refreshMode: 'debounce', refreshRate: 2000, skipOnMount: true }

  useEffect(() => {
    if (width && height) {
      setCount(count => count + 1);
      let _style: any = {}
      let _vars: any = []
      definition && definition.forEach((element: any) => {
        if (width > element.size) {
          _vars = element.values
          element.values.forEach((value: any, index: number) => {
            _style["--epods--cnt-" + (index + 1)] = value;
          });
        }
      });
      setVars(_style)
      props.onChange && props.onChange(_vars, width, height)
    }
  }, [width, height]);

  return <div ref={ref}
    className={props.className}
    style={vars}>
    {/* <div>{`Main div resized ${count} times`}</div>
    <div>{`Width: ${width}, Height: ${height}`}</div>
    {JSON.stringify(vars)}
    <hr /> */}
    {props.children}
  </div>;
};
